import { Link } from "react-router-dom";
import type { Drama } from "@/mocks/dramas";

interface DramaCardProps {
  drama: Drama;
  showSummary?: boolean;
}

export default function DramaCard({ drama, showSummary = true }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors duration-200 cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={drama.poster}
          alt={`${drama.title} 封面`}
          title={`${drama.title}·出轨的妻子影视大全`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute top-2.5 left-2.5 rounded-md bg-primary-600/90 px-2 py-0.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          {drama.type}
        </span>
        <span className="absolute top-2.5 right-2.5 flex items-center gap-1 rounded-md bg-background-50/90 px-2 py-0.5 text-xs font-semibold text-accent-600 backdrop-blur-sm">
          <i className="ri-star-fill text-[11px]" />
          {drama.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-col flex-1 p-3.5">
        <h3 className="font-heading text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {drama.title}
        </h3>
        <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500">
          <span>{drama.year}</span>
          <span className="w-px h-3 bg-background-300" />
          <span>{drama.genre}</span>
          {drama.episodes > 0 && (
            <>
              <span className="w-px h-3 bg-background-300" />
              <span>{drama.episodes}集</span>
            </>
          )}
        </div>
        {showSummary && (
          <p className="mt-2 text-xs leading-5 text-foreground-600 line-clamp-3">{drama.summary}</p>
        )}
        <div className="mt-3 pt-3 border-t border-background-100 flex flex-wrap gap-1.5">
          {drama.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}